import React from "react";
import { useSelector } from "react-redux";
import { selectCasesByReportTypeData } from "../../../../features/reports/case/ticketsByReportType";
import {
  selectCaseAssignedData,
  selectCaseResolvedData,
} from "../../../../features/reports/case/ticketsByStatus";
import { IReportValue } from "../../../../features/reports/common";
import { IconNames } from "../../common/SimpleStat";
import { StatItemType, StatsRow } from "../../common/StatsRow";
import { getTranslations } from "../../../../features/translations/translationsUtils";

export const getTotal = (cases: IReportValue[]) => cases.reduce(
  (accum, item) => (accum += item.value as number),
  0
);

export const CasesStats: React.FunctionComponent = () => {
  const data = useSelector(selectCasesByReportTypeData);
  const resolved = useSelector(selectCaseResolvedData);
  const assigned = useSelector(selectCaseAssignedData);

  const stats: StatItemType[] = [
    {
      description: getTranslations('REPORT_REGISTERED_CASES'),
      iconName: IconNames.Cases,
      mainText: getTotal(data).toString(),
    },
    {
      description: getTranslations('REPORT_ASSIGNED_CASES'),
      iconName: IconNames.CasesAssigned,
      mainText: getTotal(assigned).toString(),
    },
    {
      description: getTranslations('REPORT_SOLVED_CASES'),
      iconName: IconNames.CasesActive,
      mainText: getTotal(resolved).toString(),
    },
  ];
  return <StatsRow statsData={stats} />;
};
